import { Tooltip, TooltipProps } from '@chakra-ui/react';

Tooltip.defaultProps = {
  hasArrow: true,
  placement: 'top',
  closeOnClick: false,
} as TooltipProps;

export default Tooltip;
